import { Button } from "@mui/material";
import YouTube from "../assets/Youtube.png";

export default function YouTubeButton() {
  return (
    <Button
      component="a"
      sx={{ fontSize: "large" }}
      role={undefined}
      variant="outlined"
      tabIndex={-1}
      href="https://www.youtube.com/@vladislavskirilovics2178"
      target="_blank"
      startIcon={
        <img src={YouTube} style={{ height: "2.5em" }} alt="Youtube logo" />
      }
    >
      Youtube
    </Button>
  );
}
